<template>
  <div>
    <modal v-if="openedElement" :backdrop="false" movable content-class="element-details-modal" @close="closeElementDetails">
      <element-details :element="openedElement" :options="{ breadcrumb: true }" @close="closeElementDetails($event)"></element-details>
    </modal>
    <modal v-if="openedColorPickerElement" :backdrop="false" :size="openedColorPickerElement.isType('milestone') ? 'sm' : 'md'" movable
           @close="closeColorPicker">
      <color-picker :target="openedColorPickerElement" :planning="openedColorPickerElement.getPlanning()" disable-renaming @close="closeColorPicker"></color-picker>
    </modal>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ElementDetails from '@/components/ElementDetails/ElementDetails';
  import ColorPicker from '@/components/ColorPicker/ColorPicker';

  export default {
    components: {
      ElementDetails,
      ColorPicker,
    },
    computed: {
      ...mapState('ui/kanban', ['openedElement', 'openedColorPickerElement']),
    },
    created() {
      this.$store.commit('ui/kanban/reset');
    },
    methods: {
      ...mapActions('ui/kanban', ['closeElementDetails', 'closeColorPicker']),
    },
  };
</script>
